import { Component, inject, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { PAGE_TEXT } from '../../../constants/system-pages.constants';
import { clearSystemPageAccess } from '../../../../guard/navigation-flag.guard';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { LoginService } from '../../../services/login-service/login.service';

@Component({
  selector: 'app-error-boundary',
  templateUrl: './error-boundary.html',
  styleUrls: ['./error-boundary.scss']
})
export class ErrorBoundaryComponent implements OnDestroy {
  protected readonly text = PAGE_TEXT.errorBoundary;
  private authService = inject(MsalService);
  private readonly loginService = inject(LoginService);
  private router = inject(Router);

  constructor(private location: Location) { }

  goBack(): void {
    this.logout();
  }

  logout(): void {
    this.loginService.clearUsername();
    localStorage.removeItem('tokenId');

    const accounts = this.authService.instance.getAllAccounts();

    let activeAccount = this.authService.instance.getActiveAccount();
    if (!activeAccount && accounts.length > 0) {
      activeAccount = accounts[0];
      this.authService.instance.setActiveAccount(activeAccount);
    }

    this.authService.instance.logoutRedirect({
      account: activeAccount,
      postLogoutRedirectUri: '/',
    });
  }

  refreshPage(): void {
    sessionStorage.setItem('app-return-url', '/workspace');
    window.location.href = '/workspace';
  }

  ngOnDestroy(): void {
    clearSystemPageAccess();
  }
}